'use strict';

var Sugar = require('sugar-core');

require('../enumerable/build/buildFromIndexMethodsCall');

module.exports = Sugar.Array.reduceRightFromIndex;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/array/reduceRightFromIndex.js
// module id = 417
// module chunks = 0